import { render, staticRenderFns } from "./OrderConfiguration.vue?vue&type=template&id=23e90a4c&"
import script from "./OrderConfiguration.vue?vue&type=script&lang=js&"
export * from "./OrderConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./OrderConfiguration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports